


















































































































































































































































































































































































































































































































































































































































































import http from "@/axios/http-common";
import registerHf from "@/services/registerHf";
// import TimeStamp from "@/components/pemeriksaan/assesmen/TimeStamp.vue";
import DateFormat from "@/utility/DateFormat";
import { appModule } from "@/store/modules/app";
import { calcBmi, calcBSA } from "@/utils/rumus-kesehatan";
import { storePasien } from "@/store/modules/pasien";
// import InputField from "../reg_hf/InputField.vue";
import InputField2 from "../reg_hf/InputField2.vue";
// import InputPreview from "../reg_hf/InputPreview.vue";
import InputPreview2 from "../reg_hf/InputPreview2.vue";
import { toggleHeartFailureIndicator } from "@/utility/PasienTagHelper";

export default {
  name: "RegisterHfInput",

  mounted() {
    this.getByRegister();
  },

  inject: {
    isReadOnly: { default: () => () => false }
  },

  components: {
    // InputField,
    InputField2,
    // InputPreview,
    InputPreview2,
  },

  props: {
    register: {
      type: String || Number,
      required: true,
    },
    load: {
      type: Boolean,
      required: false,
    },
    penampilanKlinisKategori: Array,
    statusGiziCategory: Array,
    optimalisasiDosisCategory: Array,
    ekokardiografiKategori: Array,
    ecgKategori: Array,
    followUpCategory: Array,
    qolCategory: Array,
    nyhaClassCategory: Array,
    laboratoriumCategory: Array,
    cathCategory: Array,
    fungsiGinjalCategory: Array,
    ranapOutcomeCategory: Array,
  },

  data() {
    return {
      inputHOption: [
        { text: "H-0", value: 0 },
        { text: "H-30", value: 30 },
        { text: "H-6Bln", value: 180 },
        { text: "H-1Thn", value: 360 },
        { text: "H-2Thn", value: 720 },
        { text: "H-3Thn", value: 1080 },
        { text: "H-5Thn", value: 1800 },
      ],
      hValue: 0,
      panel: [],
      saving: false,
      id: null,
      diagnosis: null,
      pengobatan: {
        common: [
          {
            name: "Furosemide",
            value: null,
            dosis: null,
            note: null,
          },
          {
            name: "ACE-I",
            value: null,
            dosis: null,
            note: null,
          },
          {
            name: "ARB",
            value: null,
            dosis: null,
            note: null,
          },
          {
            name: "Beta Blockers",
            value: null,
            dosis: null,
            note: null,
          },
          {
            name: "MRA",
            value: null,
            dosis: null,
            note: null,
          },
          {
            name: "Ivabradine",
            value: null,
            dosis: null,
            note: null,
          },
          {
            name: "Digoksin",
            value: null,
            dosis: null,
            note: null,
          },
          {
            name: "ASA",
            value: null,
            dosis: null,
            note: null,
          },
          {
            name: "ARNI",
            value: null,
            dosis: null,
            note: null,
          },
        ],
        otherHeart: [],
        otherNonHeart: [],
      },
      penampilanKlinis: {
        klin_tensi: null,
        klin_nadi: null,
        klin_riw_hf: null,
        klin_riw_pci: null,
        klin_riw_op_katup: null,
        klin_hipo_perifer: null,
        klin_edema_perifer: null,
        klin_old_mi: null,
        klin_anoreksia: null,
        klin_diabetes: null,
        klin_hipertensi: null,
        klin_smoker: null,
        klin_ckd: null,
        klin_kemo: null,
        klin_nyha_class: null,
      },
      statusGizi: {
        gizi_bb: null,
        gizi_tb: null,
        gizi_bsa: null,
        gizi_bmi: null,
        gizi_albumin: null,
      },
      optimalisasiDosis: {
        od_acei: null,
        od_betablocker: null,
        od_mra: null,
      },
      ekokardiografi: {
        eko_ef: null,
        eko_tapse: null,
        eko_mr: null,
        eko_as: null,
        eko_ph: null,
      },
      ecg: {
        ecg_sinus: null,
        ecg_af: null,
        ecg_bbb: null,
      },
      laboratorium: {
        hb: null,
        hmt: null,
        leukosit: null,
        asam_urat: null,
        gds: null,
        gdp: null,
        gd2jpp: null,
        na: null,
        k: null,
      },
      qol: {
        qol1: null,
        qol2: null,
        qol3: null,
        qol4: null,
        qol5: null,
      },
      smwt: "",
      follow_up: null,
      examined_at: new Date(),
      record: null,
      cath: {
        cad: null,
      },
      fungsiGinjal: {
        ureum: null,
        bun: null,
        creatinin: null,
        gfr_mdrd: null,
      },
      ranapOutcome: {
        date_in: null,
        date_out: null,
        lama_rawat: null,
        is_meninggal: null,
      },
    };
  },

  methods: {
    setQolValueTitle(val) {
      return this.inputHOption.find((search) => {
        return search.value === val;
      }).text;
    },
    openExpandable(val) {
      // this.panel = [val];
      console.log("open " + val);
    },
    closeExpandable() {
      // this.panel = [];
    },
    formatDate(tgl) {
      return DateFormat.formatDate(tgl);
    },
    addObatHeartOther() {
      this.pengobatan.otherHeart.push({
        name: "",
        value: true,
        dosis: null,
        note: "",
      });

      this.$nextTick(() => {
        const idxCount = this.pengobatan.otherHeart.length;

        this.$refs["otherHeartName"][idxCount - 1].focus();
      });
    },
    addObatNonHeart() {
      this.pengobatan.otherNonHeart.push({
        name: "",
        value: true,
        dosis: null,
        note: "",
      });

      const idxCount = this.pengobatan.otherNonHeart.length;

      this.$refs["otherNonHeartName"][idxCount - 1].focus();
    },
    removeObat(cat, idx) {
      console.log([cat, idx]);
      if (cat === "otherHeart") {
        this.pengobatan.otherHeart.splice(idx, 1);
      } else if (cat === "otherNonHeart") {
        this.pengobatan.otherNonHeart.splice(idx, 1);
      }
    },
    checkedObatJantung(item, idx) {
      if (item.value) {
        this.$nextTick(() => {
          this.$refs["commonDosis"][idx].focus();
        });
      } else {
        item.dosis = "";
        item.note = "";
      }
    },
    save() {
      if (!this.saving) {
        this.saving = true;

        const save = this.id
          ? registerHf.updateRegHfRecord(this.id, this.dataSend)
          : registerHf.createRegHfRecord(this.dataSend);

        const msg = this.id
          ? "Berhasil Ubah Register HF"
          : "Berhasil Simpan Register HF";

        save
          .then((response) => {
            this.id = response.id;

            appModule.NoticeDelay(msg);

            this.$emit("successSave");
          })
          // .catch(err => {
          //   console.log(err.response);
          //   alert("error! " + err.response.status);
          // })
          .finally(() => {
            this.saving = false;
          });
      } else {
        alert(
          "mohon tunggu masih ada proses penyimpanan yang sedang berjalan..."
        );
      }
    },
    update() {
      if (!this.saving) {
        this.saving = true;

        http
          .putData(`/register-heart-failure/${this.id}`, this.dataSend)
          .then((response) => {
            console.log(response);
            appModule.NoticeDelay("Berhasil Ubah Register HF");
          })
          .catch((err) => {
            console.log(err.response);
            if (err.response) {
              alert("error! " + err.response.status);
            }
          })
          .finally(() => {
            this.saving = false;
          });
      } else {
        alert(
          "mohon tunggu masih ada proses penyimpanan yang sedang berjalan..."
        );
      }
    },
    setExamineTime(val) {
      this.examined_at = val;
    },
    getByRegister() {
      registerHf
        .getByRegister(this.register)
        .then((response) => {
          this.record = response.data;
          // console.log(response.data);

          if (response.data) {
            this.setInput(response.data);
          }
        })
        .finally(() => {
          this.loadRecord = false;

          console.log(this.record);
        });

      // console.log(["get by register", this.register]);
    },
    setInput(val) {
      this.id = val.id;
      this.pasien_rm = val.pasien_rm;
      this.register = val.register_id;
      this.hValue = val.h;
      this.diagnosis = val.diagnosis;
      this.pengobatan = val.pengobatan ?? this.pengobatan;
      this.penampilanKlinis = this.penampilanKlinisKategori.reduce(
        (o, key) => ({ ...o, [key.index]: this.record[key.index] }),
        {}
      );
      this.statusGizi = this.statusGiziCategory.reduce(
        (o, key) => ({ ...o, [key.index]: this.record[key.index] }),
        {}
      );
      this.optimalisasiDosis = this.optimalisasiDosisCategory.reduce(
        (o, key) => ({ ...o, [key.index]: this.record[key.index] }),
        {}
      );
      this.ekokardiografi = this.ekokardiografiKategori.reduce(
        (o, key) => ({ ...o, [key.index]: this.record[key.index] }),
        {}
      );
      this.ecg = this.ecgKategori.reduce(
        (o, key) => ({ ...o, [key.index]: this.record[key.index] }),
        {}
      );
      this.laboratorium = val.laboratorium ?? this.laboratorium;
      this.qol = val.qol ?? this.qol;
      this.smwt = val.smwt;
      this.follow_up = val.follow_up;
      this.examined_at = val.examined_at;
      this.cath = val.cath ?? this.cath;
      this.fungsiGinjal = val.fungsi_ginjal ?? this.fungsiGinjal;
      this.ranapOutcome = val.ranap_outcome ?? this.ranapOutcome;
    },
    onPanelStateChange(val) {
      this.$nextTick(function () {
        setTimeout(() => {
          this.$refs["field" + val][0].focus();
        }, 500);
      });
    },
    calcGFR(val) {
      console.log("umur", this.umur);
      const gfr =
        Math.round(
          186.3 * Math.pow(val, -1.154) * Math.pow(this.umur, -0.203) * 100
        ) / 100;

      return this.pasien.jk && this.pasien.jk.substring(0, 1) === "P"
        ? (gfr * 0.742).toFixed(2)
        : gfr.toFixed(2);
    },
    convDecimal(val) {
      console.log(val);
      return val ? val.replace(/,/g, ".") : "";
    },
    toggleRegHF() {
      toggleHeartFailureIndicator(
        async () => {
          await storePasien.getPasienTag();
        },
        () => {
          storePasien.getPasienTag();
        }
      );
    },
  },

  computed: {
    readOnly() {
      return this.isReadOnly();
    },
    dataSend() {
      const data = {
        id: this.id,
        pasien_rm: this.rm,
        register_id: this.register,
        h: this.hValue,
        diagnosis: this.diagnosis,
        pengobatan: this.pengobatan,
        ...this.penampilanKlinis,
        ...this.statusGizi,
        ...this.optimalisasiDosis,
        ...this.ekokardiografi,
        ...this.ecg,
        laboratorium: this.laboratorium,
        qol: this.qol,
        smwt: this.smwt,
        follow_up: this.follow_up,
        examined_at: this.examined_at,
        cath: this.cath,
        fungsi_ginjal: this.fungsiGinjal,
        ranap_outcome: this.ranapOutcome,
      };

      return data;
    },
    showQOLField() {
      return this.hValue === 0 || this.hValue === 180 ? true : false;
    },
    rm() {
      return this.pasien.rm;
    },
    pasien() {
      return storePasien.identitasPasien;
    },
    umur() {
      const getAge = (birthDate) =>
        Math.floor(
          (new Date().getTime() - new Date(birthDate).getTime()) / 3.15576e10
        );

      const tglLahir = this.pasien.tgl_lahir,
        dob = `${tglLahir.substring(6)}-${tglLahir.substring(
          3,
          5
        )}-${tglLahir.substring(0, 2)}`;

      return getAge(dob);
    },
    los() {
      const dateIn = this.ranapOutcome.date_in,
        dateOut = this.ranapOutcome.date_out,
        diff = Math.abs(
          new Date(dateOut).getTime() - new Date(dateIn).getTime()
        );

      return dateIn && dateOut
        ? Math.ceil(diff / (1000 * 60 * 60 * 24)) + 1
        : null;
    },
    hasRegHFTag() {
      return storePasien.isTagRegHF;
    },
  },

  watch: {
    "statusGizi.gizi_bb": function (val) {
      this.statusGizi.gizi_bmi = calcBmi(this.statusGizi.gizi_tb, val);
      this.statusGizi.gizi_bsa = calcBSA(this.statusGizi.gizi_tb, val);
    },
    "statusGizi.gizi_tb": function (val) {
      this.statusGizi.gizi_bmi = calcBmi(val, this.statusGizi.gizi_bb);
      this.statusGizi.gizi_bsa = calcBSA(val, this.statusGizi.gizi_bb);
    },
    "fungsiGinjal.creatinin": function (val) {
      this.fungsiGinjal.gfr_mdrd = val ? this.calcGFR(val) : "";
    },
    los: function (val) {
      this.ranapOutcome.lama_rawat = val;
    },
    "ranapOutcome.is_meninggal": function (val) {
      if (val && !this.follow_up) {
        this.follow_up = 2;
      } else if (!val && this.follow_up === 2) {
        this.follow_up = null;
      }
    },
  },
};
